const formateDate = function (timestamp) {
    if (timestamp === 0 || timestamp == null) {
      return ''
    } else {
      var date = new Date(timestamp)
      var Y = date.getFullYear() + '年'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月'
      var D = date.getDate() < 10 ? '0' + date.getDate() + '日' : date.getDate() + '日'
      var H = date.getHours() + '时'
      var M2 = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + '分'
      // var S = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D
      //return Y + M + D + H + M2
    }
  }
  
  const getYmd = function (myTimeString) {
    var arr0 = myTimeString.split(' ')
    var arr1 = arr0[0]
    var arr = arr1.split('-')
    var o = {
      Y: arr[0],
      M: arr[1],
      d: arr[2]
    }
    const newTimeString = o.Y +'-'+ o.M + '-' + o.d
    return newTimeString
  }
  
  const getY = function (myTimeString) {
    var arr0 = myTimeString.split(' ')
    var arr1 = arr0[0]
    var arr = arr1.split('-')
    var o = {
      Y: arr[0],
      M: arr[1],
      d: arr[2]
    }
    const newTimeString = o.Y
    return newTimeString
  }
  
  const getMd = function (myTimeString) {
    var arr0 = myTimeString.split(' ')
    var arr1 = arr0[0]
    var arr = arr1.split('-')
    var o = {
      Y: arr[0],
      M: arr[1],
      d: arr[2]
    }
    const newTimeString = o.M + '-' + o.d
    return newTimeString
  }
  
  const getMonthday = function (myTimeString) {
    var arr0 = myTimeString.split(' ')
    var arr1 = arr0[0]
    var arr = arr1.split('-')
    var o = {
      Y: arr[0],
      M: arr[1],
      d: arr[2]
    }
    const newTimeString = o.M + '-' + o.d
    return newTimeString
  }
  
  
  const getDictLabel = function (index, dictArr) {
    if(dictArr){
      for (var i = 0; i < dictArr.length; i++) {
        if (dictArr[i].dictValue == index) {
          return dictArr[i].dictLabel
        }
      }
    }
    else{
      return ""
    }  
  }
  
  const getDictIndex = function (dictArr, label) {
    for (var i = 0; i < dictArr.length; i++) {
      if (dictArr[i].dictLabel == label) {
        return dictArr[i].dictValue
      }
    }
  }
  
  const getFileSizeKb = function (size) {
    var num1 = Math.floor(size / 1024)
    var num2 = Math.floor(size / 1024 / 1024)
    var num3 = Math.floor(size / 1024 / 1024 / 1024)
    if (num1 == 0) {
      return size + "B"
    }
    if (num1 < 1024) {
      return num1 + "KB"
    }
    if (num1 > 1024 && num2 < 1024) {
      return num2 + "MB"
    }
    if (num2 > 1024) {
      return num3 + "GB"
    }
  }
  const setUserName = function(username){
    if(username == ""){
        return ""
    }
    else{
        var len = username.length
        var firstName = username.slice(0,1)
        var namestr = ""
        for(var i=1; i<len;i++){
          namestr += "*"
        }
        return firstName + namestr
    }
  }
  
  const shieldTel = function(tel){
    if(tel == ""){
        return ""
    }
    else{
        var reg = /^(\d{3})\d{4}(\d{4})$/      
        return tel.replace(reg, "$1****$2")
    }
  }
  
  export {
    formateDate,
    getMonthday,
    getFileSizeKb,
    getDictIndex,
    getDictLabel,
    setUserName,
    getY,
    getMd,
    getYmd,
    shieldTel
  }
  


// WEBPACK FOOTER //
// ./src/filters/index.js